/* Vicca: Crea tu pack — estado del builder (memoria + localStorage), filtros, add to cart. */
if (!customElements.get('pack-builder')) {
  customElements.define(
    'pack-builder',
    class PackBuilder extends HTMLElement {
      constructor() {
        super();
        this.storageKey = 'vicca_pack';
        this.maxProducts = parseInt(this.dataset.maxProducts, 10) || 3;
        this.chosen = this.loadFromStorage();

        this.grid = this.querySelector('[id^="PackBuilderGrid"]');
        this.panelEl = this.querySelector('[data-pack-panel]');
        this.drawerEl = this.querySelector('[data-pack-drawer]');
        this.statusEl = this.querySelector('[data-pack-status]');
        this.barStatusEl = this.querySelector('[data-pack-bar-status]');
        this.barToggle = this.querySelector('[data-pack-bar-toggle]');
        this.closeBtn = this.querySelector('[data-pack-close]');
        this.backdropEl = this.querySelector('[data-pack-backdrop]');
        this.progressEl = this.querySelector('[data-pack-progress]');
        this.chosenListEl = this.querySelector('[data-pack-chosen]');
        this.totalsEl = this.querySelector('[data-pack-totals]');
        this.unlockedEl = this.querySelector('[data-pack-unlocked]');
        this.totalPriceEl = this.querySelector('[data-pack-total-price]');
        this.oldPriceEl = this.querySelector('[data-pack-old-price]');
        this.savingsEl = this.querySelector('[data-pack-savings]');
        this.submitBtn = this.querySelector('[data-pack-submit]');
        this.filterButtons = Array.from(this.querySelectorAll('.vicca-pack-filter'));

        this.addEventListener('click', this.handleClick.bind(this));
        this.addEventListener('change', this.handleVariantChange.bind(this));
        this.filterButtons.forEach((btn) =>
          btn.addEventListener('click', () => this.applyFilter(btn.dataset.filter, btn))
        );

        document.addEventListener('keydown', (evt) => {
          if (evt.key === 'Escape') this.closeDrawer();
        });

        this.render();
      }

      openDrawer() {
        if (!this.panelEl) return;
        this.panelEl.classList.add('is-open');
        if (this.barToggle) this.barToggle.setAttribute('aria-expanded', 'true');
        if (this.backdropEl) this.backdropEl.hidden = false;
      }

      closeDrawer() {
        if (!this.panelEl) return;
        this.panelEl.classList.remove('is-open');
        if (this.barToggle) this.barToggle.setAttribute('aria-expanded', 'false');
        if (this.backdropEl) this.backdropEl.hidden = true;
      }

      toggleDrawer() {
        if (this.panelEl && this.panelEl.classList.contains('is-open')) {
          this.closeDrawer();
        } else {
          this.openDrawer();
        }
      }

      loadFromStorage() {
        try {
          const raw = localStorage.getItem(this.storageKey);
          return raw ? JSON.parse(raw) : [];
        } catch (e) {
          return [];
        }
      }

      saveToStorage() {
        try {
          localStorage.setItem(this.storageKey, JSON.stringify(this.chosen));
        } catch (e) {
          /* private mode / storage full: state stays in memory only */
        }
      }

      applyFilter(filter, activeButton) {
        this.filterButtons.forEach((btn) => {
          const isActive = btn === activeButton;
          btn.classList.toggle('is-active', isActive);
          btn.setAttribute('aria-selected', isActive ? 'true' : 'false');
        });

        this.querySelectorAll('[data-product-card]').forEach((card) => {
          if (filter === 'all') {
            card.hidden = false;
            return;
          }
          const collections = (card.dataset.productCollections || '').split(',');
          card.hidden = !collections.includes(filter);
        });
      }

      handleClick(evt) {
        const toggle = evt.target.closest('[data-add-to-pack], .vicca-pack-card__media');
        if (toggle) {
          this.toggleProduct(toggle.closest('[data-product-card]'));
          return;
        }

        const remove = evt.target.closest('[data-pack-remove]');
        if (remove) {
          this.removeProduct(remove.dataset.packRemove);
          return;
        }

        if (evt.target.closest('[data-pack-bar-toggle]')) {
          this.toggleDrawer();
          return;
        }

        if (evt.target.closest('[data-pack-close]')) {
          this.closeDrawer();
          return;
        }

        if (evt.target.closest('[data-pack-backdrop]')) {
          this.closeDrawer();
          return;
        }

        if (evt.target.closest('[data-pack-submit]')) {
          this.addPackToCart();
        }
      }

      handleVariantChange(evt) {
        const select = evt.target.closest('.vicca-pack-card__variant');
        if (!select) return;
        const card = select.closest('[data-product-card]');
        const option = select.options[select.selectedIndex];
        const img = card && card.querySelector('.vicca-pack-card__image');
        if (img && option && option.dataset.image) {
          img.removeAttribute('srcset');
          img.src = option.dataset.image;
        }
        // El tono elegido puede estar ya en el pack o no: solo refrescamos el estado de la tarjeta.
        this.render();
      }

      cardKey(card) {
        const select = card.querySelector('.vicca-pack-card__variant');
        return select ? select.value : card.dataset.productVariantId || card.dataset.productId;
      }

      toggleProduct(card) {
        if (!card) return;
        const id = card.dataset.productId;
        const key = this.cardKey(card);
        const existingIndex = this.chosen.findIndex((item) => item.key === key);

        if (existingIndex > -1) {
          this.chosen.splice(existingIndex, 1);
        } else {
          if (this.chosen.length >= this.maxProducts) return;
          const select = card.querySelector('.vicca-pack-card__variant');
          const image = card.querySelector('img');
          const option = select ? select.options[select.selectedIndex] : null;
          this.chosen.push({
            id,
            key,
            title: option ? `${card.dataset.productTitle} · ${option.textContent.trim()}` : card.dataset.productTitle,
            price: parseFloat(card.dataset.productPrice) || 0,
            variantId: select ? select.value : card.dataset.productVariantId || null,
            image: image ? image.src : ''
          });
        }

        this.saveToStorage();
        this.render();
      }

      removeProduct(key) {
        this.chosen = this.chosen.filter((item) => item.key !== key);
        this.saveToStorage();
        this.render();
      }

      render() {
        // sync selected state on cards that match restored localStorage state
        // y refresca el precio con el dato vivo del card (defensa ante estado
        // de localStorage guardado con un formato de precio antiguo/distinto).
        this.chosen = this.chosen.filter((item) => item.key);
        this.chosen.forEach((item) => {
          const card = this.querySelector(`[data-product-id="${item.id}"]`);
          if (card) {
            const livePrice = parseFloat(card.dataset.productPrice);
            if (!Number.isNaN(livePrice)) item.price = livePrice;
          }
        });
        // Tarjeta marcada solo si el tono que muestra ahora mismo está en el pack.
        this.querySelectorAll('[data-product-card]').forEach((card) => {
          const inPack = this.chosen.some((item) => item.key === this.cardKey(card));
          card.classList.toggle('is-selected', inPack);
          const count = this.chosen.filter((item) => item.id === card.dataset.productId).length;
          const badge = card.querySelector('[data-pack-card-count]');
          if (badge) { badge.textContent = count > 1 ? `×${count}` : ''; badge.hidden = count < 2; }
        });

        const count = this.chosen.length;
        const missing = Math.max(0, 2 - count);

        if (count === 0) {
          this.statusEl.textContent = window.vicca_pack_i18n.missing_products.replace('{{ count }}', 2);
        } else if (missing > 0) {
          this.statusEl.textContent = window.vicca_pack_i18n.missing_products.replace('{{ count }}', missing);
        } else {
          this.statusEl.textContent = window.vicca_pack_i18n.ready;
        }

        const target = this.maxProducts;
        if (this.barStatusEl) {
          const packForBar = this.currentPack();
          this.barStatusEl.textContent = packForBar
            ? window.vicca_pack_i18n.bar_status
                .replace('{{ count }}', count)
                .replace('{{ target }}', target)
                .replace('{{ price }}', this.formatMoney(packForBar.price))
            : window.vicca_pack_i18n.bar_status_empty
                .replace('{{ count }}', count)
                .replace('{{ target }}', target);
        }

        this.progressEl.style.width = `${Math.min(100, (count / 3) * 100)}%`;

        this.chosenListEl.innerHTML = this.chosen
          .map(
            (item) => `
              <li class="vicca-pack-chosen-item">
                ${item.image ? `<img class="vicca-pack-chosen-item__image" src="${item.image}" alt="" loading="lazy">` : ''}
                <div class="vicca-pack-chosen-item__info">
                  <p class="vicca-pack-chosen-item__title">${item.title}</p>
                </div>
                <button type="button" class="vicca-pack-chosen-item__remove" data-pack-remove="${item.key}" aria-label="${window.vicca_pack_i18n.remove_product}">×</button>
              </li>
            `
          )
          .join('');

        const packData = this.currentPack();

        if (packData) {
          const sum = this.chosen.reduce((total, item) => total + item.price, 0);
          const savings = Math.max(0, sum - packData.price);
          const percent = sum > 0 ? Math.round((savings / sum) * 100) : 0;

          this.totalsEl.hidden = false;
          this.totalPriceEl.textContent = this.formatMoney(packData.price);
          this.oldPriceEl.textContent = this.formatMoney(sum);

          if (percent > 0) {
            this.unlockedEl.textContent = window.vicca_pack_i18n.unlocked_percent.replace('{{ percent }}', percent);
            this.savingsEl.hidden = false;
            this.savingsEl.textContent = window.vicca_pack_i18n.savings_percent
              .replace('{{ amount }}', this.formatMoney(savings))
              .replace('{{ percent }}', percent);
          } else {
            this.unlockedEl.textContent = window.vicca_pack_i18n.unlocked;
            this.savingsEl.hidden = true;
            this.savingsEl.textContent = '';
          }

          this.submitBtn.disabled = false;
          this.submitBtn.removeAttribute('aria-disabled');
        } else {
          this.totalsEl.hidden = true;
          this.submitBtn.disabled = true;
          this.submitBtn.setAttribute('aria-disabled', 'true');
        }
      }

      currentPack() {
        // Packs del catálogo con precio cerrado: 2 productos o 3 productos.
        const count = this.chosen.length;
        if (count === 2) {
          return { variantId: this.dataset.packTwoVariantId, price: parseFloat(this.dataset.packTwoPrice) };
        }
        if (count === 3) {
          return { variantId: this.dataset.packThreeVariantId, price: parseFloat(this.dataset.packThreePrice) };
        }
        return null;
      }

      formatMoney(amount) {
        return `${amount.toFixed(2).replace('.', ',')} €`;
      }

      addPackToCart() {
        const pack = this.currentPack();
        if (!pack || !pack.variantId) { if (this.statusEl) this.statusEl.textContent = 'Este pack no está disponible ahora mismo.'; return; }

        this.submitBtn.setAttribute('aria-disabled', 'true');
        this.submitBtn.disabled = true;
        this.submitBtn.classList.add('loading');

        const properties = { _pack: 'Pack Vicca' };
        this.chosen.forEach((item, index) => {
          properties[`${window.vicca_pack_i18n.product_label} ${index + 1}`] = item.title;
        });

        const body = JSON.stringify({
          id: pack.variantId,
          quantity: 1,
          properties,
          sections: this.cartSections(),
          sections_url: window.location.pathname
        });

        fetch(`${window.routes ? window.routes.cart_add_url : '/cart/add'}.js`, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body
        })
          .then((response) => response.json())
          .then((response) => {
            this.submitBtn.classList.remove('loading');
            if (response.status) {
              this.submitBtn.removeAttribute('aria-disabled');
              this.submitBtn.disabled = false;
              return;
            }

            this.chosen = [];
            this.saveToStorage();
            this.querySelectorAll('[data-product-card].is-selected').forEach((card) =>
              card.classList.remove('is-selected')
            );
            this.render();
            this.closeDrawer();
            this.openCartDrawer(response);
          })
          .catch(() => {
            this.submitBtn.classList.remove('loading');
            this.submitBtn.removeAttribute('aria-disabled');
            this.submitBtn.disabled = false;
          });
      }

      cartSections() {
        const drawer = document.querySelector('cart-drawer');
        if (drawer && typeof drawer.getSectionsToRender === 'function') {
          return drawer.getSectionsToRender().map((section) => section.id);
        }
        return ['cart-drawer', 'cart-icon-bubble'];
      }

      openCartDrawer(cartAddResponse) {
        const drawer = document.querySelector('cart-drawer');
        if (!drawer) {
          window.location = window.routes ? window.routes.cart_url : '/cart';
          return;
        }

        fetch(`${window.location.pathname}?sections=${this.cartSections().join(',')}`)
          .then((response) => response.json())
          .then((sections) => {
            drawer.renderContents({ sections });
          })
          .catch(() => {
            drawer.renderContents({ sections: {} });
          });
      }
    }
  );
}
